import api from '@/api';

function toAbsoluteUrl(url) {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  const rawBase = process.env.VUE_APP_API_URL || '/api';
  const base = rawBase.replace(/\/api\/?$/, '');
  // Soporta API_URL relativa (/api) usando origin para construir URL absoluta de assets
  const originBase = !base
    ? window.location.origin
    : /^https?:\/\//i.test(base)
      ? base
      : `${window.location.origin}${base}`;
  return url.startsWith('/') ? `${originBase}${url}` : `${originBase}/${url}`;
}

export async function fetchEmpresaConfig() {
  const { data } = await api.get('/config/empresa');
  const raw = data.empresa || data;
  if (raw && raw.logo_url) raw.logo_url = toAbsoluteUrl(raw.logo_url);
  if (raw && raw.logo) raw.logo = toAbsoluteUrl(raw.logo);
  return raw;
}

export async function saveEmpresaConfig(payload, logoFile = null) {
  const fd = new FormData();
  Object.entries(payload).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== '') fd.append(k, v);
  });
  if (logoFile) fd.append('logo', logoFile);
  // normaliza respuesta
  const normalize = (raw) => {
    if (raw && raw.logo_url) raw.logo_url = toAbsoluteUrl(raw.logo_url);
    return raw;
  };
  // PUT single record; si no existe usa POST
  try {
    const { data } = await api.put('/config/empresa', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return normalize(data.empresa || data);
  } catch (e) {
    if (e.response?.status === 404) {
      const { data } = await api.post('/config/empresa', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const raw = data.empresa || data;
      if (raw && raw.logo_url) raw.logo_url = toAbsoluteUrl(raw.logo_url);
      return raw;
    }
    throw e;
  }
}

// cache simple en memoria para recibo sin re-fetch constante
let _cache = null;
export async function getEmpresaCached(force = false) {
  if (_cache && !force) return _cache;
  try {
    _cache = await fetchEmpresaConfig();
  } catch {
    _cache = null;
  }
  return _cache;
}
export function clearEmpresaCache() { _cache = null; }
